import type { ActionContext } from 'vuex'

import type { ActionClass, AuthState } from '../../../models'
import type { StorageService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { AUTH_CONSTS } from '../../auth/auth.consts'

export class LoadStateFromStorageAction implements ActionClass {
  static execute(this: void, { commit }: ActionContext<AuthState, any>): string {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    const token = storageService.getItem(AUTH_CONSTS.storage.token)
    const refreshToken = storageService.getItem(AUTH_CONSTS.storage.refreshToken)
    const keepLoggedIn = storageService.getItem(AUTH_CONSTS.storage.keepLoggedIn) === 'true'
    commit(AUTH_CONSTS.mutations.setState, {
      token,
      refreshToken,
      keepLoggedIn,
    })
    return token
  }
}
